import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--omit-blank-params" on a form, with
// data-action="formdata->shared--omit-blank-params#omit"
// Leaves empty fields out of the submitted parameters.
export default class extends Controller {
  omit(event) {
    for (const [key, value] of [...event.formData.entries()]) {
      if (!value) event.formData.delete(key);
    }
  }
}
